export const DEFAULT_FEATURES = [
  { farm_selector: true },
  { season_selector: true },
  { map_card: true },
  { crop_info_card: false },
  { task_list_card: true },
  { timeline_card: true },
  { metrics_card: true },
  { gdd_current_data: false },
  { page_timeline: true },
  { page_map: true },
  { page_tasks: true },
  { page_metrics: true },
  { page_templates: false },
  { theme_toggle: true },
  { invite_users: false },
  { add_farm: true },
  { add_crops: true },
  { add_crops_bulk: true },
  { add_plots: true },
  { add_tasks: true },
  { add_reports: true },
  { edit_farm: true },
  { edit_crops: true },
  { edit_plots: true },
  { edit_tasks: true },
  { sidebar_collapse: true },
  { sidebar_beta_pages: false },
  { cache_debug: false },
  { timeline_task_overlay: false },
  { export_data: true },
  { export_ics: true },
  { export_timeline: true },
  { storage_usage: true },
  { customize_dashbaord: true },
  { timeline_controls: true },
  { task_list_controls: true },
  { end_season: true },
  { log_harvest: true },
  { crop_relationships: true },
  { version_info: false },
  { crop_template_collections: false },
  { crop_successions: true },
]

export const DEFAULT_PREFERENCES = [
  { ready_window_offset_days: 7 },
  { temperature_unit: '°C' },
  { distance_unit: 'm' },
  { area_unit: 'm²' },
  { mass_unit: 'kg' },
]
